import medizenLogo from '../assets/icons/logo.png'
import hero1 from '../assets/images/main-page/baner.jpg'
import hero2 from '../assets/images/main-page/baner.jpg'
import hero3 from '../assets/images/main-page/baner.jpg'
import about from '../assets/images/main-page/doctor-holding-older-patient-s-hands.png'
import download from '../assets/images/main-page/phone.png'
import news1 from '../assets/images/main-page/looking-hair.jpg'
import news2 from '../assets/images/main-page/feeling-unwel.jpg'
import news3 from '../assets/images/main-page/girl-with-medicine.jpg'
import news4 from '../assets/images/main-page/man-taking-his-pills.jpg'
import news5 from '../assets/images/main-page/woman-laying-bed.jpg'
import news6 from '../assets/images/main-page/sick-with-laptop.jpg'
import news7 from '../assets/images/main-page/kid-with-father.jpg'
import socialMedia from '../assets/images/main-page/social.png'
import enamad from '../assets/images/enamad.jpg'
import ecunion from '../assets/images/ecunion.jpg'
import aboutUsBanner from '../assets/images/about-us/baner.jpg'
import doctor1 from '../assets/images/about-us/woman-1.jpg'
import doctor2 from '../assets/images/about-us/woman-2.jpg'
import doctor3 from '../assets/images/about-us/man-1.jpg'
import doctor4 from '../assets/images/about-us/man-2.jpg'
import doctor5 from '../assets/images/about-us/man-3.jpg'
import contactUsBanner from '../assets/images/contact-us/baner.jpg'
import service from '../assets/icons/folder-download.png'

export const IMAGES = {
    home:{
        hero:{
            h1:hero1,
            h2:hero2,
            h3:hero3
        },
        services:service,
        about,
        download,
        news:{
            news1:news1,
            news2:news2,
            news3:news3,
            news4:news4,
            news5:news5,
            news6:news6,
            news7:news7
        },
        social:socialMedia,
    },
    about:{
        hero: aboutUsBanner,
        doctors:{
            doctor1:doctor1,
            doctor2:doctor2,
            doctor3:doctor3,
            doctor4:doctor4,
            doctor5:doctor5,
        },
        comments:{
            cm1: doctor1,
            cm2:doctor2,
            cm3:doctor3,
            cm4:doctor4,
            cm5:doctor5
        },
        
    },
    contact:{
        hero:contactUsBanner,
    },
    footer:{
        enamad:enamad,
        ecunion:ecunion,
        logo:medizenLogo
    }
}